export default __webpack_public_path__ + "static/media/space_part7.75893186.png";